import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "pay-hold",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "pay-hold-title"
}
const _hoisted_2 = { class: "pay-hold__panel" }
const _hoisted_3 = { class: "pay-hold__actions" }

import AppIcon from '@/components/common/AppIcon.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'MallPayHold',
  emits: ["close", "refresh"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: "pay-hold__x",
          "aria-label": "결제 안내 닫기",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createVNode(AppIcon, {
            icon: "mdi-close",
            size: 20
          })
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("p", {
          id: "pay-hold-title",
          class: "pay-hold__title"
        }, "결제 중", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("p", { class: "pay-hold__text" }, " 토스 결제창을 닫아도 이 주문은 결제 대기로 남습니다. 아직 결제된 금액은 없습니다. 새로고침하면 결제창을 다시 준비합니다. ", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "pay-hold__btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
          }, "닫기"),
          _createElementVNode("button", {
            type: "button",
            class: "pay-hold__btn is-go",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('refresh')))
          }, "새로고침")
        ])
      ])
    ])
  ]))
}
}

})